// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"40c06e30","62":"9a8dfc69","79":"40c06e30","558":"40c06e30","594":"3d09b8ca","604":"40c06e30","766":"aacb3a17","797":"e8c87ae2","830":"9a255e4c","845":"40c06e30","983":"5e32f725"}[chunkId] + ".chunk.css";
};